import { render, staticRenderFns } from "./CancelledOrdersModal.vue?vue&type=template&id=20f86965&scoped=true"
import script from "./CancelledOrdersModal.vue?vue&type=script&lang=ts"
export * from "./CancelledOrdersModal.vue?vue&type=script&lang=ts"
import style0 from "./CancelledOrdersModal.vue?vue&type=style&index=0&id=20f86965&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f86965",
  null
  
)

export default component.exports